import React, {useState, useEffect} from 'react';
import Layout from '../containers/Layout';
import {Logo263} from '../components/Logo263';
import {DivInfoProject} from '../components/DivInfoProject';
import {NavBar} from "../components/NavBar";
import SearchBar from "../components/SearchBar";
import ContNintyWidth from '../components/ContNintyWidth';
import LoginButton from "../components/LoginButton";
import LogoutButton from "../components/LogoutButton";
import axios from 'axios';
import { useParams } from 'react-router-dom';
import {TitleH1} from '../components/TitleH1'; 
import { BotonWD } from '../components/BotonWD';
import { useHistory } from "react-router-dom";

const Project = (props) => 
{    
    const apiKey = props.apiKey;
    const headerOrigin = new Headers();
    headerOrigin.append('Access-Control-Allow-Origin', '*');
    headerOrigin.append('Access-Control-Allow-Headers', "Origin, X-Requested-With, Content-Type, Accept");
    const [resultsGames, setResultsGames] = useState([]);
    const [loading, setLoading] = useState(true);
    let { query, page } = useParams();
    const [numberPage, setNumberPage] = useState(Number(page));
    let history = useHistory();
    const addNumberPage=()=>
    {
        let newNumber = numberPage+1;
        history.replace("/Project/"+query+"/"+newNumber);
        history.push('/temp');
        history.goBack();
        
    }

    const substractNumberPage=()=>
    {
        let newNumber = numberPage-1;
        history.replace("/Project/"+query+"/"+newNumber);
        history.push('/temp');
        history.goBack();    }

    useEffect( () =>
    {
        const fetchData=async() => 
        {
            try{
                setLoading(true);
                const response = await axios.get(`https://api.rawg.io/api/games?key=${apiKey}&page=${numberPage}&search=${query}`);
                const data = response.data.results;
                //const data= response.data.slice(0,30);
                setResultsGames(data);
                console.log(resultsGames);
                setLoading(false);
            }
            catch(error)
            {
                console.error('Mi error :C  : ', error);
            }
        }
        (query !== "") && fetchData();
    },[query]);
    
    return (
        <div className="App">
            <Layout>
                    <Logo263 ToSide={true}></Logo263>
                    <ContNintyWidth>
                        <NavBar/>
                            <LoginButton/>
                            <LogoutButton/>
                            <TitleH1 Color="#35BDE4" FontS="70px" FontF="HackedFont" style={{color: 'white', margin: 0}} >Proyecto</TitleH1>
                            <SearchBar numberPage={numberPage}/>
                            <div className='BotonsPaginas'>
                            <BotonWD FontSize="25px" Color="#E31075" ColorAdentro="#181E35" Tamanio="25" EventToClick={substractNumberPage}>
                                    Página anterior
                            </BotonWD>
                                
                            <BotonWD FontSize="25px" Color="#35BDE4" ColorAdentro="#181E35" Tamanio="25" EventToClick={addNumberPage}>
                                Página siguiente
                            </BotonWD>
                            </div>
                            <div className="divsInfo">
                                {loading ? <img className="LoadingGif" src="/img/loading.gif" alt="loading"/> : ""}
                                {
                                    resultsGames.length != 0 ? resultsGames.map((obj)=> <DivInfoProject DataGame={obj}></DivInfoProject>):"No se encontraron resultados de su búsqueda"}
                            </div>
                    </ContNintyWidth>
            </Layout>
        </div>
    )
}

export default Project;